// extracted by mini-css-extract-plugin
export default {"shell":"time-allocated-overview_shell__kVUzy"};